import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import { CabinetJson, FurnitureJson } from 'lib/modelBuilder/Data';
import { FurnitureEditorContext } from 'lib/constraintsChecker/FurnitureEditor';

export function displayCabinetReference(
  reference: string | number | undefined,
) {
  return reference
    ? reference.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    : '';
}

export function serializeFurniture(furniture: Furniture) {
  return JSON.stringify(furniture, Furniture.replacer);
}

export function saveFurniture(furniture: Furniture) {
  /**
   * Save cabinets in local storage
   */
  const data = serializeFurniture(furniture);
  localStorage.setItem('furniture', data);
}

export function deserializeFurniture(furnitureJson: string): Furniture | null {
  const localFurnitureData = JSON.parse(furnitureJson);
  return Furniture.fromModel(localFurnitureData as FurnitureJson);
}

export function loadFurniture(): Furniture | null {
  /**
   * load cabinets from local storage
   */
  const dataJson = localStorage.getItem('furniture');
  let furniture = undefined;
  if (dataJson) {
    furniture = deserializeFurniture(dataJson);
  }

  if (furniture && furniture.quantity > 0) return furniture;
  else return null;
}

export function deserializeCabinet(cabinetJson: string): Cabinet | null {
  const localCabinetData = JSON.parse(cabinetJson);
  return Cabinet.fromModel(localCabinetData as CabinetJson);
}

export function getContext(url: string): FurnitureEditorContext {
  const salesRegex = /https?:\/\/(www)?\.?(.*?)kewlox.com(\/shop)?\/adminkew/g;
  if (url.match(salesRegex)) return FurnitureEditorContext.sales;

  return FurnitureEditorContext.webShop;
}
